// Ugyanez a domain-vizsgálat megvan a public/index.html head-scriptjében is (a
// favicon készlethez, ami már az első festés előtt kell). Ha itt változik a
// feltétel, ott is át kell vezetni, különben a két oldal más márkát szolgál ki.
export const isKelep = document.location.host === process.env.REACT_APP_KELEP_DOMAIN;

export const currentTheme = isKelep ? "kelep" : "breki";

export const siteTitle = isKelep ? "Kelep" : "Breki";
